module.exports = __webpack_public_path__ + "static/media/nunito_regular.522cb9b7.ttf";